import modelBaseV2 from "../model-base-v2.model";
import { v4 as uuidv4 } from 'uuid';
var PosmModel = {

    getPosmMasterHierarchy: (options = {
        fromLevel: 1,
        toLevel: 100
    }) => {
        var query = modelBaseV2.toQueryString(options);
        return modelBaseV2.get(`/api/posmmaster/getHierarchyTree?${query}`);
    },
    getPosmMasterModel: (options = {
        levelCodeList: [],
        pageIndex:1,
        pageSize:10
    }) => {

        return modelBaseV2.post("/api/posm/model", {body:options});
    },
    getWarehouseList: (warehouseIDOrName)=>{
        return modelBaseV2.get("/api/posm/warehouses?" + "warehouseIDOrName=" + warehouseIDOrName);
    },
    getSerialNoList: (options = {
        storeCodeList:[],
        warehouseIDList:[],
        storeTypeList:[],
        goodsTypeList:[],
        locationList:[],
        serialNo:"",
        date:"",
        pageIndex:1,
        pageSize:10
    })=>{
        return modelBaseV2.post("/api/posm/serials", {body:options});
    }
    ,
    downloadSerialNoList: (options = {
        storeCodeList:[],
        warehouseIDList:[],
        storeTypeList:[],
        goodsTypeList:[],
        locationList:[],
        serialNo:"",
        date:""
    })=>{

        return modelBaseV2.postDownload("/api/posm/serials/download", {body:options}, "Download_SerialNoList"+ uuidv4());
    }
}

export default PosmModel;